let config = {
  inputLabel: 'comparisonText',
  key: 'comparisontext',
  inputType: 'textfield',
};

export default config;
